(($) => {

    $.fn.navTabScroll = function () {
        this.each((i, el) => {
            const navTab = $(el);
            const selected = navTab.hasClass('active');
            if (selected) {
                scrollToNavTab(navTab, false);
            }
        });
        this.on('show.bs.tab', event => {
            const navTab = $(event.target);
            scrollToNavTab(navTab, true);
        });

        function scrollToNavTab(navTab, smooth) {
            const navItem = navTab.closest('.nav-item');
            const navTabs = navItem.closest('.nav-tabs');
            const listWidth = navTabs.width();
            const scrollLeft = navTabs.scrollLeft();
            const itemLeft = navItem.position().left + scrollLeft;
            const itemWidth = navItem.width();
            const scrollLeft2 = itemLeft + (itemWidth - listWidth) / 2;
            if (smooth) {
                navTabs.animate({
                    scrollLeft: scrollLeft2,
                }, {
                    duration: 200,
                });
            }
            else {
                navTabs.scrollLeft(scrollLeft2);
            }
        }
    };

})(jQuery);
